import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// ONE shared Inbox summary for every nav badge/header: module cache + window event `bf:inbox-changed` (dispatched after
// any save / trash / bulk action that can change the queue) + a slow poll. Admin-only endpoint; silently idle otherwise.
export const INBOX_CHANGED = "bf:inbox-changed";
let cache = null;
let inflight = null;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn(cache));

export const refreshInbox = () => {
  if (inflight) return inflight;
  inflight = api.get("/admin/inbox/summary").then((r) => { cache = r.data; notify(); return cache; }).catch(() => cache).finally(() => { inflight = null; });
  return inflight;
};
export const inboxChanged = () => { window.dispatchEvent(new Event(INBOX_CHANGED)); };

export const useInboxSummary = (enabled) => {
  const [data, setData] = useState(cache);
  useEffect(() => {
    if (!enabled) return undefined;
    listeners.add(setData);
    if (!cache) refreshInbox();
    const onChange = () => refreshInbox();
    window.addEventListener(INBOX_CHANGED, onChange);
    const id = setInterval(refreshInbox, 30000);
    return () => { listeners.delete(setData); window.removeEventListener(INBOX_CHANGED, onChange); clearInterval(id); };
  }, [enabled]);
  return enabled ? data : null;
};
